
import {
	Card,
	CardBody,
	CardHeader,
	Stack,
	Tag,
	Text,
} from '@chakra-ui/react';

import type { CardRootProps } from '@chakra-ui/react';
import { NextImageWithSkeleton } from '@packages/chakra-v3';
import ProductPrice from '../ProductPrice/ProductPrice';

export type ProductCardProps = CardRootProps & {
	product: {
		name:       string;
		coverImage: string;
		collection: {
			name: string;
		};
		price: {
			amount:      number;
			discounted?: number | null;
			currency:    'THB' | 'USD';
		};
	};
	onClickProductCard: () => void;
};

const ProductCard = ({
	aspectRatio = 'square',
	product,
	onClickProductCard,
	...rest
}: ProductCardProps) => {
	return (
		<Card.Root
			cursor={'pointer'}
			p={0}
			onClick={onClickProductCard}
			{...rest}
		>
			<CardHeader p={0} position={'relative'}>
				<NextImageWithSkeleton
					alt={product.name}
					aspectRatio={aspectRatio}
					objectFit={'cover'}
					src={product.coverImage}
					width={'100%'}
				/>
				<Tag.Root
					flexShrink={0}
					position={'absolute'}
					px={3}
					py={0.5}
					right={3}
					top={3}
					w={'fit-content'}
				>
					<Tag.Label>{product.collection.name}</Tag.Label>
				</Tag.Root>
			</CardHeader>
			<CardBody p={4}>
				<Stack gap={0} layerStyle={'black'}>
					<Text lineClamp={1} textStyle={'title'}>{product.name}</Text>
					<ProductPrice price={product.price} />
				</Stack>
			</CardBody>
		</Card.Root>
	);
};

export default ProductCard;
